import { showSelectedItems } from '../service/projects'
import { updateSelectedSkillsStandards } from '../service/SkillsStandardsService'

export interface ApplyAndRefetchParams {
  projectId: string
  contentsIds: string[]
  skillsIds: string[]
  existingContentsIds: string[]
  existingSkillsIds: string[]
}

export interface RefetchSelectedItemsResult {
  success: boolean
  error?: string
  selectedItems?: {
    contents: any[]
    specificSkills: any[]
  }
}

export async function applyAndRefetchAIItems(
  params: ApplyAndRefetchParams
): Promise<RefetchSelectedItemsResult> {
  const { projectId, contentsIds, skillsIds, existingContentsIds, existingSkillsIds } = params

  try {
    const allContentsIds = [...new Set([...existingContentsIds, ...contentsIds])]
    const allSkillsIds = [...new Set([...existingSkillsIds, ...skillsIds])]
    const allItemsIds = [...allContentsIds, ...allSkillsIds]

    const updateData = {
      lv4_item_ids: allItemsIds
    }

    const updateResult = await updateSelectedSkillsStandards(projectId, updateData)

    if (updateResult.errors && updateResult.errors !== '') {
      throw new Error(updateResult.errors)
    }

    await new Promise(resolve => setTimeout(resolve, 300))

    const response = await showSelectedItems(projectId)

    if (!response) {
      throw new Error('Resposta vazia da API')
    }

    const contents = response.contents || []
    const skills = response.specificSkills || response.specific_skills || []

    return {
      success: true,
      selectedItems: {
        contents,
        specificSkills: skills
      }
    }
  } catch (error: any) {
    return {
      success: false,
      error: error.message || 'Erro ao aplicar e recarregar items'
    }
  }
}
